export const COUNTRIES = {
  us: 'UNITED_STATES',
  ca: 'CANADA',
  uk: 'GREAT_BRITAIN',
};
